export default __webpack_public_path__ + "static/media/iphone13pro.724da10d.png";